import React from "react";
import { TeamAreaThreeItem } from "./TeamAreaThreeItem";
import { getTeam } from "../../data/team";
import { useTranslation } from "react-i18next";

export const TeamAreaThree = () => {
  const { t } = useTranslation();
  const team = getTeam(t);

  return (
    <section className="team-area-three">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title-two text-center mb-50 tg-heading-subheading animation-style1">
              <span className="sub-title tg-element-title">
                {t("home.teamSubTitle")}
              </span>
              <h2 className="title tg-element-title">
                {t("home.teamTitle")}
              </h2>
              <p>{t("home.teamText")}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {team.map((member) => (
            <div
              key={member.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-8"
            >
              <TeamAreaThreeItem member={member} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
